export default __webpack_public_path__ + "static/renshin-animation-b3b7c6fb17b4d1df1935a3cfe8a441ec.webm";